import React from "react";
import { AdvisorsReactGAHandlers, CollegeReactGAHandlers, TestScoreStrategyReactGAHandlers } from "./ReactGAHandlers";
import axios from "axios";
import { collegeMap } from "./collegeMap";
import { getUserByToken } from "../modules/auth/core/_requests";

export { };

export const URL = process.env.REACT_APP_COLLEGE_API
export const FRONTEND_URL = process.env.REACT_APP_URL
export const stripePromiseKey = process.env.REACT_APP_STRIPE_PROMISE_KEY || ''
export const specializedRankingsAccessCode = process.env.REACT_APP_PERMISSION_GROUP_SPECIALIZED_RANKINGS
export const rdSpendAccessCode = process.env.REACT_APP_PERMISSION_GROUP_RD_SPEND
export const safetyAccessCode = process.env.REACT_APP_PERMISSION_GROUP_SAFETY
export const ecPremiumAccessCode = process.env.REACT_APP_EC_PREMIUM_GROUP
// Sets purchase modal to advisor connect 
export const advisorConnectAccessCode = process.env.REACT_APP_PERMISSION_GROUP_ADVISOR_CONNECT

export const specializedRankingsPriceID = process.env.REACT_APP_PRICE_ID_SPECIALIZED_RANKINGS
export const rdSpendPriceID = process.env.REACT_APP_PRICE_ID_RD_SPEND
export const safetyPriceID = process.env.REACT_APP_PRICE_ID_SAFETY
export const personalizedExpertHelpPriceID = process.env.REACT_APP_PRICE_ID_PERSONALIZED_EXPERT_HELP
export const personalizedExpertHelpPriceIDNoCost = process.env.REACT_APP_PRICE_ID_PERSONALIZED_EXPERT_HELP_NO_COST

export const personalizedExpertHelpProductID = process.env.REACT_APP_PRODUCT_ID_PERSONALIZED_EXPERT_HELP
// mobile vs desktop containers
// {/* Use Bootstrap d-md-block to render while 768px or above */}
// <div className='d-none d-md-flex' style={{width: '100%'}}></div>
// {/* Mobile Replacement, only shows at below 768px */}
// <div className='d-flex d-md-none'  style={{width: '100%'}}></div>

// track mobile state
// const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

//   useEffect(() => {
//     const updateScreenSize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener('resize', updateScreenSize);
//     return () => window.removeEventListener('resize', updateScreenSize);
//   }, []);

export const currentYear = new Date().getFullYear()

// Premium Insights Price IDs
export const ecPremiumPriceIDs = [
  {
    activityID: 35,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_35,
    description: "Premium Insights for Beaver Works Summer Institute (BWSI)"
  },
  {
    activityID: 48,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_48,
    description: "Premium Insights for Boston University Research in Science & Engineering Program (RISE)"
  },
  {
    activityID: 64,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_64,
    description: "Premium Insights for California State Summer School for Mathematics & Science (COSMOS)"
  },
  {
    activityID: 108,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_108,
    description: "Premium Insights for Concord Review"
  },
  {
    activityID: 115,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_115,
    description: "Premium Insights for Coolidge Scholarship"
  },
  {
    activityID: 116,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_116,
    description: "Premium Insights for Coolidge Senators Program"
  },
  {
    activityID: 144,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_144,
    description: "Premium Insights for Economics for Leaders (EFL)"
  },
  {
    activityID: 195,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_195,
    description: "Premium Insights for Hampshire College Summer Studies in Math (HCSSiM)"
  },
  {
    activityID: 279,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_279,
    description: "Premium Insights for Management & Technology Summer Institute (M&TSI)"
  },
  {
    activityID: 341,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_341,
    description: "Premium Insights for National Security Language Initiative for Youth (NSLI-Y)"
  },
  {
    activityID: 343,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_343,
    description: "Premium Insights for National Speech & Debate Tournament"
  },
  {
    activityID: 350,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_350,
    description: "Premium Insights for New York Times Student Contests"
  },
  {
    activityID: 383,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_383,
    description: "Premium Insights for Princeton Prize in Race Relations"
  },
  {
    activityID: 395,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_395,
    description: "Premium Insights for Regeneron Science Talent Search (STS)"
  },
  {
    activityID: 399,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_399,
    description: "Premium Insights for Research Science Institute (RSI)"
  },
  {
    activityID: 404,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_404,
    description: "Premium Insights for Ross Mathematics Program"
  },
  {
    activityID: 414,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_414,
    description: "Premium Insights for Science Internship Program (SIP)"
  },
  {
    activityID: 422,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_422,
    description: "Premium Insights for Simons Summer Research Program"
  },
  {
    activityID: 437,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_437,
    description: "Premium Insights for Stanford Institutes of Medicine Summer Research Program (SIMR)"
  },
  {
    activityID: 448,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_448,
    description: "Premium Insights for Stanford Summer Humanities Institute"
  },
  {
    activityID: 452,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_452,
    description: "Premium Insights for Stanford University Mathematics Camp (SUMaC)"
  },
  {
    activityID: 465,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_465,
    description: "Premium Insights for Summer Academy for Math and Science (SAMS)"
  },
  {
    activityID: 469,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_469,
    description: "Premium Insights for Summer Science Program"
  },
  {
    activityID: 471,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_471,
    description: "Premium Insights for Telluride Association Summer Seminar (TASS)"
  },
  {
    activityID: 476,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_476,
    description: "Premium Insights for Coca-Cola Scholars Program"
  },
  {
    activityID: 545,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_545,
    description: "Premium Insights for U.S. Presidential Scholars Program"
  },
  {
    activityID: 601,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_601,
    description: "Premium Insights for Leadership in the Business World (LBW)"
  },
  {
    activityID: 609,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_609,
    description: "Premium Insights for Yale Bassett Award for Community Engagement"
  },
  {
    activityID: 616,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_616,
    description: "Premium Insights for Yale Summer Program in Astrophysics (YSPA)"
  },
  {
    activityID: 622,
    priceID: process.env.REACT_APP_PREMIUM_INSIGHTS_PRICE_ID_622,
    description: "Premium Insights for Yale Young Global Scholars"
  }
]

export const returnECPremiumPriceID = (activityID) => {

  const id = typeof activityID === 'number' ? activityID : parseInt(activityID);

  let priceIDObj = ecPremiumPriceIDs.find(item => item.activityID === id)

  if (priceIDObj) {
    return priceIDObj.priceID
  }
}

export const advisorPriceIDs = [
  {
    advisorID: 1,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_1,
    description: "45 minute virtual session with Rutvik"
  },
  {
    advisorID: 2,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_2,
    description: "45 minute virtual session with Anuj"
  },
  {
    advisorID: 3,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_3,
    description: "45 minute virtual meeting with Richard"
  },
  {
    advisorID: 4,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_4,
    description: "45 minute virtual meeting with Erica"
  },
  {
    advisorID: 5,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_5,
    description: "45 minute virtual meeting with Daniel"
  },
  {
    advisorID: 6,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_6,
    description: "45 minute virtual meeting with Kareena"
  },
  {
    advisorID: 7,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_7,
    description: "45 minute virtual meeting with Rachel"
  },
  {
    advisorID: 8,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_8,
    description: "45 minute virtual meeting with Aminah"
  },
  {
    advisorID: 9,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_9,
    description: "45 minute virtual meeting with Andrea"
  },
  {
    advisorID: 10,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_10,
    description: "45 minute virtual meeting with Chelsea"
  },
  {
    advisorID: 11,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_11,
    description: "45 minute virtual meeting with Pujitha"
  },
  {
    advisorID: 12,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_12,
    description: "45 minute virtual meeting with Pranav"
  },
  {
    advisorID: 13,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_13,
    description: "45 minute virtual meeting with Liana"
  },
  {
    advisorID: 14,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_14,
    description: "45 minute virtual meeting with Tanush"
  },
  {
    advisorID: 15,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_15,
    description: "45 minute virtual meeting with Bernice"
  },
  {
    advisorID: 16,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_16,
    description: "45 minute virtual meeting with Sresth"
  },
  {
    advisorID: 17,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_17,
    description: "45 minute virtual meeting with Audrey"
  },
  {
    advisorID: 18,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_18,
    description: "45 minute virtual meeting with Kevin"
  },
  {
    advisorID: 19,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_19,
    description: "45 minute virtual meeting with Ash"
  },
  {
    advisorID: 20,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_20,
    description: "45 minute virtual meeting with Elliott"
  },
  {
    advisorID: 21,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_21,
    description: "45 minute virtual session with Isabel"
  },
  {
    advisorID: 22,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_22,
    description: "45 minute virtual session with Cassidy"
  },
  {
    advisorID: 23,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_23,
    description: "45 minute virtual session with Justin"
  },
  {
    advisorID: 24,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_24,
    description: "45 minute virtual session with Alex"
  },
  {
    advisorID: 25,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_25,
    description: "45 minute virtual session with Sophia"
  },
  {
    advisorID: 26,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_26,
    description: "45 minute virtual session with Nikhil"
  },
  {
    advisorID: 27,
    priceID: process.env.REACT_APP_PRICE_ID_ADVISOR_CONNECT_27,
    description: "45 minute virtual session with Varnica"
  }
]

export const returnAdvisorPriceID = (advisorId) => {

  const id = typeof advisorId === 'number' ? advisorId : parseInt(advisorId);

  let priceIDObj = advisorPriceIDs.find(item => item.advisorID === id)

  if (priceIDObj) {
    return priceIDObj.priceID
  }
}

export const returnItemFromProductID = (productID) => {

  switch (true) {
    case productID == specializedRankingsPriceID:
      return 'Specialized Rankings Report'
    case productID == rdSpendPriceID:
      return 'Research and Development (R&D) Spend Report'
    case productID == safetyPriceID:
      return 'Safety & Crime Ratings Report'
    case productID == personalizedExpertHelpPriceID:
      return 'Personalized Expert Help'
  }

  try {
    let ecObj = ecPremiumPriceIDs.find(item => item.priceID == productID)

    let advisorObj = advisorPriceIDs.find(item => item.priceID == productID)

    if (ecObj) {
      let description = ecObj.description
      let result = description.split("Premium Insights for ")[1];
      return `Extracurricular Insights Report: ${result}`
    }

    if (advisorObj) {
      let description = advisorObj.description
      return `Advisor Consultation: ${description}`
    }

  } catch (error) {
    console.log('Error finding a valid product', error)
  }

}

export const returnHyphenatedString = (string: string) => {
  return string
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export const returnMobileSortLabel = (label: string) => {

  switch (label) {
    case 'Alphabetical':
      return 'Alpha'
    case 'Num Colleges':
      return '# Colleges'
    case 'Median SAT':
      return 'SAT'
    case 'Median ACT':
      return 'ACT'
    case 'Metarank':
      return 'Rank'
    case 'Earnings':
      return 'Pay'
    case 'Undergrads':
      return 'Size'
    default:
      return label
  }
}

export const pageRoutes = {
  home: '/home',

  dashboard: '/dashboard',

  conditional: '/:conditional',

  collegeDetailTest: `/${collegeMap.some(college => college.hyphenated)}`,

  overviewIntroduction: '/introduction',
  overviewCollegeAppWalkthrough: '/college-application-walkthrough',
  overviewCollegeAppWalkthroughForRouter: '/college-application-walkthrough/:hashPath',
  overviewCollegeAppWalkthroughWithHash: (hashPath) => { return `/college-application-walkthrough/${hashPath}` },
  overviewAdmissionsAdvice: '/admissions-advice',
  overviewAdmissionsAdviceForRouter: '/admissions-advice/:hashPath',
  overviewAdmissionsAdviceWithHash: (hashPath) => { return `/admissions-advice/${hashPath}` },
  overviewWithId: (view) => { return `/${view}` },

  marketingGeneric: '/marketing-preview/:content',
  marketingWithId: (content) => { return `/marketing-preview/${content}` },

  collegeSearch: '/colleges',
  collegeDetailGeneric: '/:collegeNameHyphenated',
  collegeDetailWithId: (collegeNameHyphenated) => { return `/${collegeNameHyphenated}` },

  ecSearch: '/extracurriculars',
  ecDetailGeneric: '/:ecNameHyphentated',
  ecDetailWithId: (ecNameHyphentated) => { return `/${ecNameHyphentated}` },

  majorSearch: '/majors',
  majorDetailGeneric: '/:majorNameHyphenated/',
  majorDetailWithId: (majorNameHyphenated) => { return `/${majorNameHyphenated}` },

  advisorSearch: '/advisors',
  advisorDetailGeneric: '/advisor-detail/:advisorId',
  advisorDetailWithId: (advisorId) => { return `/advisor-detail/${advisorId}` },
  advisorNetwork: '/advisors-network-overview',

  ecPremiumInsightsBase: '/extracurricular-insights',
  ecPremiumInsightsGeneric: '/extracurricular-insights/:ecId',
  // ecPremiumInsightsWithId: (ecId) => { return `/extracurricular-insights/${ecId}` },
  // ecPremiumInsightsGeneric: '/extracurricular-insights-:ecId',
  ecPremiumInsightsWithId: (hyphenatedECName) => { return `/extracurricular-insights-${hyphenatedECName}` },

  premiumSpecializedRankings: '/college-specialized-rankings',
  premiumCrimeSafety: '/college-crime-and-safety-report',
  premiumRDSpend: '/college-research-spend-report',

  premiumSpecializedRankingsWithId: (hyphenatedName) => { return `/${hyphenatedName}-specialized-rankings` },
  premiumCrimeSafetyWithId: (hyphenatedName) => { return `/${hyphenatedName}-crime-and-safety-report` },
  premiumRDSpendWithId: (hyphenatedName) => { return `/${hyphenatedName}-research-spend-report` },

  personalizedExpertHelp: '/personalized-expert-help',

  // premiumSpecializedRankings: '/:college-specialized-rankings',
  // premiumCrimeSafety: '/:college-crime-and-safety-report',
  // premiumRDSpend: '/:college-research-spend-report',

  signIn: '/sign-in',
  signUp: '/sign-up',
  //
  testScoreStrategy: '/test-score-strategy',
  collegeDataVisualization: '/college-data-visualization',
  userProfileGeneric: '/user-profile/:userId',
  userProfileWithId: (userId) => { return `/user-profile/${userId}` },
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  about: '/about',
  faq: '/faq',
  contact: '/contact',
  blog: 'https://blog.nextfour.ai'
}

const collegeLogoSVGFiles = (require as any).context("../../custom_assets/college_logos", false, /\.svg$/);

const collegeLogoSVGFilePaths = collegeLogoSVGFiles.keys();

export const collegeLogos: Record<string, string> = collegeLogoSVGFilePaths.reduce((acc: Record<string, string>, path: string) => {

  const filename: any = path.replace(/^.*[\\\/]/, '').split('.').shift();

  const collegeId = filename.split('-')[0];

  const svg = collegeLogoSVGFiles(path);

  acc[collegeId] = svg.default || svg;

  return acc;
}, {});

const collegeHeroJPGFiles = (require as any).context("../../custom_assets/college_heros", false, /\.jpg$/);

const collegeHeroJPGFilePaths = collegeHeroJPGFiles.keys();

export const collegeHeroes: Record<string, string> = collegeHeroJPGFilePaths.reduce((acc: Record<string, string>, path: string) => {

  const filename: any = path.replace(/^.*[\\\/]/, '').split('.').shift();

  const collegeId = filename.split('-')[0];

  const jpg = collegeHeroJPGFiles(path);

  acc[collegeId] = jpg.default || jpg;

  return acc;
}, {});

const advisorJPGFiles = (require as any).context("../../custom_assets/advisor_profile_images", false, /\.jpg$/);

const advisorJPGFilePaths = advisorJPGFiles.keys();

export const advisorJPGs: Record<string, string | null> = advisorJPGFilePaths.reduce((acc: Record<string, string | null>, path: string) => {
  const filename: any = path.replace(/^.*[\\\/]/, '').split('.').shift();
  const advisorId = filename.split('-')[0];

  try {
    const jpg = advisorJPGFiles(path);
    acc[advisorId] = jpg.default || jpg;
  } catch (e) {
    acc[advisorId] = null;
  }

  return acc;
}, {});


interface PremiumPreviews {
  (name: string, id: string): string;
}

const premiumPreviewJPGFiles = (require as any).context("../../custom_assets/premium_previews", false, /\.jpg$/);

export const premiumPreviews: PremiumPreviews = (name: string, id: string) => {
  const jpg = premiumPreviewJPGFiles(`./${name}-${id}.jpg`);
  return jpg.default || jpg;
};

// Auth group permissions 
export const permissionGroups = { Level1: [1], Level2: [1, 2] }

export const type = { 'Public': 1, 'Private': 2, 'Private for-profit': 3 }
export const typeRender = { 1: 'Public', 2: 'Private', 3: 'Private for-profit' }
export const collegeSize = { 'All': 0, 'Small': 1, 'Medium': 2, 'Large': 3, 'Very Large': 4 }
export const setting = { 'City': [11, 12], 'Suburb': [13, 21, 22, 23], 'Town': [31, 32, 33], 'Rural': [41, 42, 43] }
export const testPolicy = { 'All': 0, 'Required': 1, 'Optional': 2, 'Blind': 3 }
export const stateMap = { 1: "AL", 2: "AK", 4: "AZ", 5: "AR", 6: "CA", 8: "CO", 9: "CT", 10: "DE", 11: "DC", 12: "FL", 13: "GA", 15: "HI", 16: "ID", 17: "IL", 18: "IN", 19: "IA", 20: "KS", 21: "KY", 22: "LA", 23: "ME", 24: "MD", 25: "MA", 26: "MI", 27: "MN", 28: "MS", 29: "MO", 30: "MT", 31: "NE", 32: "NV", 33: "NH", 34: "NJ", 35: "NM", 36: "NY", 37: "NC", 38: "ND", 39: "OH", 40: "OK", 41: "OR", 42: "PA", 44: "RI", 45: "SC", 46: "SD", 47: "TN", 48: "TX", 49: "UT", 50: "VT", 51: "VA", 53: "WA", 54: "WV", 55: "WI", 56: "WY" }

export const stateArray = [
  { 1: "Alabama" }, { 2: "Alaska" }, { 4: "Arizona" },
  { 5: "Arkansas" }, { 6: "California" }, { 8: "Colorado" }, { 9: "Connecticut" }, { 10: "Delaware" }, { 11: "District of Columbia" }, { 12: "Florida" }, { 13: "Georgia" }, { 15: "Hawaii" }, { 16: "Idaho" }, { 17: "Illinois" }, { 18: "Indiana" }, { 19: "Iowa" }, { 20: "Kansas" }, { 21: "Kentucky" }, { 22: "Louisiana" }, { 23: "Maine" }, { 24: "Maryland" }, { 25: "Massachusetts" }, { 26: "Michigan" }, { 27: "Minnesota" }, { 28: "Mississippi" }, { 29: "Missouri" }, { 30: "Montana" }, { 31: "Nebraska" }, { 32: "Nevada" }, { 33: "New Hampshire" }, { 34: "New Jersey" }, { 35: "New Mexico" }, { 36: "New York" }, { 37: "North Carolina" }, { 38: "North Dakota" }, { 39: "Ohio" }, { 40: "Oklahoma" }, { 41: "Oregon" }, { 42: "Pennsylvania" }, { 44: "Rhode Island" }, { 45: "South Carolina" }, { 46: "South Dakota" }, { 47: "Tennessee" }, { 48: "Texas" }, { 49: "Utah" }, { 50: "Vermont" }, { 51: "Virginia" }, { 53: "Washington" }, { 54: "West Virginia" }, { 55: "Wisconsin" }, { 56: "Wyoming" }
]

export const returnFullStateName = (stateID) => {
  const stateObj = stateArray.find(state => Object.keys(state)[0] == stateID)

  return stateObj ? stateObj[stateID] : '-'
}

let locationOptions: any = []

stateArray.forEach((state) => {
  locationOptions.push({ value: Object.keys(state), label: Object.values(state) })
})

export { locationOptions }

export const countryMap = {
  1: 'Abkhazia', 2: 'Afghanistan', 3: 'Åland Islands', 4: 'Albania', 5: 'Algeria', 6: 'American Samoa', 7: 'Andorra', 8: 'Angola', 9: 'Anguilla', 10: 'Antarctica', 11: 'Antigua & Barbuda', 12: 'Argentina', 13: 'Armenia', 14: 'Artsakh', 15: 'Aruba', 16: 'Australia', 17: 'Austria', 18: 'Azerbaijan', 19: 'Bahamas', 20: 'Bahrain', 21: 'Bangladesh', 22: 'Barbados', 23: 'Belarus', 24: 'Belgium', 25: 'Belize', 26: 'Benin', 27: 'Bermuda', 28: 'Bhutan', 29: 'Bolivia', 30: 'Bosnia & Herzegovina', 31: 'Botswana', 32: 'Bouvet Island', 33: 'Brazil', 34: 'British Indian Ocean Territory', 35: 'British Virgin Islands', 36: 'Brunei', 37: 'Bulgaria', 38: 'Burkina Faso', 39: 'Burundi', 40: 'Cambodia', 41: 'Cameroon', 42: 'Canada', 43: 'Cape Verde', 44: 'Caribbean Netherlands', 45: 'Cayman Islands', 46: 'Central African Republic', 47: 'Chad', 48: 'Chile', 49: 'China', 50: 'Christmas Island', 51: 'Cocos', 52: 'Colombia', 53: 'Comoros', 54: 'Congo', 55: 'Cook Islands', 56: 'Costa Rica', 57: 'Croatia', 58: 'Cuba', 59: 'Curaçao', 60: 'Cyprus', 61: 'Czechia', 62: 'Côte d’Ivoire', 63: 'Denmark', 64: 'Djibouti', 65: 'Dominica', 66: 'Dominican Republic', 67: 'Ecuador', 68: 'Egypt', 69: 'El Salvador', 70: 'Equatorial Guinea', 71: 'Eritrea', 72: 'Estonia', 73: 'Eswatini', 74: 'Ethiopia', 75: 'Falkland Islands', 76: 'Faroe Islands', 77: 'Fiji', 78: 'Finland', 79: 'France', 80: 'French Guiana', 81: 'French Polynesia', 82: 'French Southern Territories', 83: 'Gabon', 84: 'Gambia', 85: 'Georgia', 86: 'Germany', 87: 'Ghana', 88: 'Gibraltar', 89: 'Greece', 90: 'Greenland', 91: 'Grenada', 92: 'Guadeloupe', 93: 'Guam', 94: 'Guatemala', 95: 'Guernsey', 96: 'Guinea', 97: 'Guinea-Bissau', 98: 'Guyana', 99: 'Haiti', 100: 'Heard & McDonald Islands', 101: 'Honduras', 102: 'Hong Kong SAR China', 103: 'Hungary', 104: 'Iceland', 105: 'India', 106: 'Indonesia', 107: 'Iran', 108: 'Iraq', 109: 'Ireland', 110: 'Isle of Man', 111: 'Israel', 112: 'Italy', 113: 'Jamaica', 114: 'Japan', 115: 'Jersey', 116: 'Jordan', 117: 'Kazakhstan', 118: 'Kenya', 119: 'Kiribati', 120: 'Kosovo', 121: 'Kuwait', 122: 'Kyrgyzstan', 123: 'Laos', 124: 'Latvia', 125: 'Lebanon', 126: 'Lesotho', 127: 'Liberia', 128: 'Libya', 129: 'Liechtenstein', 130: 'Lithuania', 131: 'Luxembourg', 132: 'Macao SAR China', 133: 'Madagascar', 134: 'Malawi', 135: 'Malaysia', 136: 'Maldives', 137: 'Mali', 138: 'Malta', 139: 'Marshall Islands', 140: 'Martinique', 141: 'Mauritania', 142: 'Mauritius', 143: 'Mayotte', 144: 'Mexico', 145: 'Micronesia', 146: 'Moldova', 147: 'Monaco', 148: 'Mongolia', 149: 'Montenegro', 150: 'Montserrat', 151: 'Morocco', 152: 'Mozambique', 153: 'Myanmar', 154: 'Namibia', 155: 'Nauru', 156: 'Nepal', 157: 'Netherlands', 158: 'New Caledonia', 159: 'New Zealand', 160: 'Nicaragua', 161: 'Niger', 162: 'Nigeria', 163: 'Niue', 164: 'Norfolk Island', 165: 'North Korea', 166: 'North Macedonia', 167: 'Northern Cyprus', 168: 'Northern Mariana Islands', 169: 'Norway', 170: 'Oman', 171: 'Pakistan', 172: 'Palau', 173: 'Palestinian Territories', 174: 'Panama', 175: 'Papua New Guinea', 176: 'Paraguay', 177: 'Peru', 178: 'Philippines', 179: 'Pitcairn Islands', 180: 'Poland', 181: 'Portugal', 182: 'Puerto Rico', 183: 'Qatar', 184: 'Romania', 185: 'Russia', 186: 'Rwanda', 187: 'Réunion', 188: 'Sahrawi Arab Democratic Republic', 189: 'Samoa', 190: 'San Marino', 191: 'Saudi Arabia', 192: 'Senegal', 193: 'Serbia', 194: 'Seychelles', 195: 'Sierra Leone', 196: 'Singapore', 197: 'Sint Maarten', 198: 'Slovakia', 199: 'Slovenia', 200: 'Solomon Islands', 201: 'Somalia', 202: 'Somaliland', 203: 'South Africa', 204: 'South Georgia & South Sandwich Islands', 205: 'South Korea', 206: 'South Ossetia', 207: 'South Sudan', 208: 'Spain', 209: 'Sri Lanka', 210: 'St. Barthélemy', 211: 'St. Helena', 212: 'St. Kitts & Nevis', 213: 'St. Lucia', 214: 'St. Martin', 215: 'St. Pierre & Miquelon', 216: 'St. Vincent & Grenadines', 217: 'Sudan', 218: 'Suriname', 219: 'Svalbard & Jan Mayen', 220: 'Sweden', 221: 'Switzerland', 222: 'Syria', 223: 'São Tomé & Príncipe', 224: 'Taiwan', 225: 'Tajikistan', 226: 'Tanzania', 227: 'Thailand', 228: 'Timor-Leste', 229: 'Togo', 230: 'Tokelau', 231: 'Tonga', 232: 'Transnistria', 233: 'Trinidad & Tobago', 234: 'Tunisia', 235: 'Turkey', 236: 'Turkmenistan', 237: 'Turks & Caicos Islands', 238: 'Tuvalu', 239: 'U.S. Outlying Islands', 240: 'U.S. Virgin Islands', 241: 'Uganda', 242: 'Ukraine', 243: 'United Arab Emirates', 244: 'United Kingdom', 245: 'United States', 246: 'Uruguay', 247: 'Uzbekistan', 248: 'Vanuatu', 249: 'Vatican City', 250: 'Venezuela', 251: 'Vietnam', 252: 'Wallis & Futuna', 253: 'Western Sahara', 254: 'Yemen', 255: 'Zambia', 256: 'Zimbabwe'
}

export const languagesMap = {
  1: 'Arabic', 2: 'Bengali', 3: 'Chinese', 4: 'English', 5: 'French', 6: 'German', 7: 'Hindi', 8: 'Italian', 9: 'Japanese', 10: 'Korean', 11: 'Lahnda', 12: 'Malay', 13: 'Marathi', 14: 'Persian', 15: 'Portuguese', 16: 'Russian', 17: 'Spanish', 18: 'Tamil', 19: 'Telugu', 20: 'Turkish', 21: 'Urdu', 22: 'Vietnamese', 23: 'Other'
}

export const activityType = [{ 1: "Summer Program" }, { 2: "Pre-College Studies" }, { 3: "Research" }, { 4: "Competition" }, { 5: "Scholarship / Award" }, { 6: "Internship" }, { 7: "Academic Enrichment" }, { 8: 'Independent' }]
export const schoolLevel = [{ 1: "High school" }, { 2: "Middle school" }, { 3: "Elementary school" }]
export const activityFormat = { 1: "In-person", 2: "Online", 3: "Hybrid" }
export const inPersonFormat = { 1: 'Residential', 2: 'Commuting' }
export const relatedInterestAreas = [
  { 1: "Artificial Intelligence" }, { 2: "Business & Economics" }, { 3: "Climate Change" }, { 4: "Community Service" }, { 5: "Computer Science" }, { 6: "Data/Analytics" }, { 7: "Engineering" }, { 8: "Entrepreneurship" }, { 9: "Finance" }, { 10: "Government & Politics" }, { 11: "History" }, { 12: "Humanities" }, { 13: "Writing & Journalism" }, { 14: "Language" }, { 15: "Law" }, { 16: "Leadership" }, { 17: "Math" }, { 18: "Medicine" }, { 19: "Performing Arts" }, { 20: "Pre-College Experience" }, { 21: "Public Speaking" }, { 22: "Religion & Faith" }, { 23: "Research" }, { 24: "Physical and Natural Sciences" }, { 25: "Social Justice" }, { 26: 'Social Sciences' }, { 27: 'Sports' }, { 28: 'Technology' }, { 29: 'Visual Arts' }
]
export const impactIndex = [{ 1: 'Good' }, { 2: 'Better' }, { 3: 'Best' }]

export const numberConverter = (num) => {
  if (typeof num !== 'number') {
    return '-'
  }

  else {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export const returnCommaSeparatedFromArray = (arr) => {

  if (arr == null) {
    return '-'
  }

  else {
    let res: any = []
    arr.forEach((a, index) => {
      if (index !== arr.length - 1) {
        res.push(`${a}, `)
      }

      else {
        res.push(a)
      }
    })

    return res
  }
}

export const returnSemiColonSeparatedFromArray = (arr) => {

  if (Array.isArray(arr) && arr.length > 0 && arr !== null) {
    let res: any = []
    arr.forEach((a, index) => {
      if (index !== arr.length - 1) {
        res.push(`${a}; `)
      }

      else {
        res.push(a)
      }
    })

    return res
  }

  else {
    return '-'
  }
}

export const returnValueInArrayOfObjects = (val, arr) => {
  for (const obj of arr) {
    for (const key in obj) {
      if (Number(key) === val) {
        return obj[key];
      }
    }
  }
  return null
}

export const returnArrayOfValues = (vals, arr) => {
  let result: any = [];

  for (const obj of arr) {
    for (const key in obj) {
      const val = Number(key);

      if (vals.includes(val)) {
        result.push(obj[key])
      }
    }
  }
  return result
}

export const getDateFromHyphenFormat = (dateWithHyphen) => {
  return new Date(dateWithHyphen.replace(/-/g, '\/'))
}

export const convertDateFormat = (fullDate) => {

  if (fullDate !== null) {
    const date = new Date(fullDate.replace(/-/g, '\/'));
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();
    const year = date.getFullYear().toString().slice(-2)

    return `${month.replace(/^0+/, '')}/${day.replace(/^0+/, '')}/${year}`;
  }

  else {
    return '-'
  }
};

export const booleanReturn = (input) => {
  if (input !== null) {
    return input === true ? 'Yes' : 'No'
  }

  else {
    return '-'
  }
}

export const separatorReturn = (index, array) => {

  if (array && array.length > 2 && array.length % 2 === 1 && index === array.length - 1) {
    return ""
  }

  else if (array && array.length > 2 && array.length % 2 === 0 && index === array.length - 2) {
    return ""
  }

  else {
    return "separator"
  }
}

export const sortLogic = (a, b, sortKey, nameKey) => {

  let aCheck = (a === undefined || a === null || a[sortKey] === undefined || a[sortKey] === null)
  let bCheck = (b === undefined || b === null || b[sortKey] === undefined || b[sortKey] === null)

  if (aCheck) {
    return -1;
  }

  if (bCheck) {
    return 1;
  }

  if (typeof a[sortKey] === 'string' && typeof b[sortKey] === 'string') {
    const primarySort = a[sortKey].localeCompare(b[sortKey]);

    if (primarySort === 0 && a[nameKey] && b[nameKey]) {
      return a[nameKey].localeCompare(b[nameKey]);
    }

    return primarySort;
  } else {
    const numA = Number(a[sortKey]);
    const numB = Number(b[sortKey]);

    if (!isNaN(numA) && !isNaN(numB)) {
      const primarySort = numA - numB;

      if (primarySort === 0 && a[nameKey] && b[nameKey]) {
        return a[nameKey].localeCompare(b[nameKey]);
      }

      return primarySort;
    } else {

      return 0;
    }
  }
};

//////// ReactGAHandlerControllers
export const reactGAPurchaseModalController = (purchaseID, advisor = undefined) => {
  return {
    purchaseID: purchaseID,
    modal: 'purchase',
    advisorID: advisor
  }
}

export const reactGACheckoutModalController = (purchaseID, advisor = undefined) => {
  return {
    purchaseID: purchaseID,
    modal: 'checkout',
    advisorID: advisor
  }
}

export const reactGAPostTransactionController = (purchaseID) => {
  return {
    purchaseID: purchaseID,
    modal: 'postTransaction'
  }
}

export const reactGATestStrategyController = () => {
  return {
    purchaseID: "null",
    modal: 'Test Strategy Edit Score Overlay'
  }
}

export const closeModalIcon = (id, ReactGAHandlerController?: any) => {

  const {
    handleGAEventPurchaseModalClose,
    handleGAEventCheckoutModalClose,
    handleGAEventPostTransactionModalClose
  } = CollegeReactGAHandlers()

  const {
    handleGAEventOverlayButton
  } = TestScoreStrategyReactGAHandlers()

  const {
    handleAdvisorGAEventConsultClose,
    handleAdvisorGAEventConsultCheckoutClose
  } = AdvisorsReactGAHandlers()

  const handlerRouter = (modal, text, advisorID) => {

    if (advisorID) {
      switch (true) {
        case modal == 'purchase':
          handleAdvisorGAEventConsultClose(advisorID);
          break;
        case modal == 'checkout':
          handleAdvisorGAEventConsultCheckoutClose(advisorID);
          break;
      }

    }

    else {
      switch (true) {
        case modal == 'purchase':
          handleGAEventPurchaseModalClose(text);
          break;
        case modal == 'checkout':
          handleGAEventCheckoutModalClose(text);
          break;
        case modal == 'postTransaction':
          handleGAEventPostTransactionModalClose(text);
          break
      }
    }
  }

  return <i
    className="bi bi-x-lg align-self-end dca-close-modal-icon"
    id={`modal_icon_${id}`}
    data-bs-dismiss="modal"
    onClick={() => {

      if (ReactGAHandlerController) {

        let modal = ReactGAHandlerController.modal
        let purchaseID = ReactGAHandlerController.purchaseID
        let text: any = ""
        let advisorID = ReactGAHandlerController.advisorID

        if (modal == 'Test Strategy Edit Score Overlay') {
          handleGAEventOverlayButton("Close")
        }

        switch (true) {
          case purchaseID === specializedRankingsAccessCode:
            text = 'Specialized Ranking'
            break;
          case purchaseID === rdSpendAccessCode:
            text = 'R&D Spend'
            break;
          case purchaseID === safetyAccessCode:
            text = 'Crime & Safety'
            break;
          case purchaseID.startsWith(ecPremiumAccessCode):
            text = 'EC Premium Insights'
            break;
        }

        handlerRouter(modal, text, advisorID)
      }

    }
    }
  ></i>
}

export const closeModalIconTestScoreGuidance = (handleGAEventOverlayButton) => {

  return <i
    className="bi bi-x-lg align-self-end dca-close-modal-icon"
    id={`modal_icon_editScoreProfile`}
    data-bs-dismiss="modal"
    onClick={() => {
      handleGAEventOverlayButton("Close")
    }}
  ></i>
}

export const simpleCloseModalIcon = (
  <i
    className="bi bi-x-lg align-self-end"
    id={`modal_icon_ dca-close-modal-icon`}
    data-bs-dismiss="modal"
  ></i>
)

export const closeModalFunction = (id) => {
  const closeModalIcon = document.getElementById(`modal_icon_${id}`);
  if (closeModalIcon) {
    closeModalIcon.click();
  }
};

export const updateTitleAndDescription = (
  page: any = undefined,
  titleParam: any = undefined,
  descriptionParam: any = undefined) => {

  const collegeDetailTitleHandler = (collegeName: string) => {
    let len = collegeName?.length

    switch (true) {
      case len <= 20:
        return `${collegeName} Acceptance Rate, Rankings, Common Data Set`
      case len <= 27:
        return `${collegeName} Acceptance Rate, Rankings, CDS Data`
      case len <= 32:
        return `${collegeName} Acceptance Rate, Rankings, CDS`
      case len <= 37:
        return `${collegeName} Acceptance Rate, CDS Data`
      case len <= 42:
        return `${collegeName} Acceptance Rate, CDS`
      default:
        return `${collegeName} Acceptance Rate`
    }
  }

  const majorDetailTitleHandler = (majorName: string) => {
    let len = majorName?.length

    switch (true) {
      case len <= 9:
        return `${majorName} Major Description, Colleges, Salary, Jobs, Popularity`
      case len <= 15:
        return `${majorName} Major Description, Colleges, Salary, Popularity`
      case len <= 21:
        return `${majorName} Major Description, Colleges, Salary, Jobs`
      case len <= 27:
        return `${majorName} Major Description, Colleges, Salary`
      case len <= 35:
        return `${majorName} Major Description, Colleges`
      case len <= 48:
        return `${majorName} Major Colleges`
      case len <= 57:
        return `${majorName} Major`
      default:
        return `${majorName}`
    }
  }

  const ecDetailTitleHandler = (ecName: string) => {
    let len = ecName?.length

    switch (true) {
      case len <= 11:
        return `${ecName} Overview, Application, Acceptance Rate, Dates, Cost`
      case len <= 17:
        return `${ecName} Overview, Application, Acceptance Rate, Dates`
      case len <= 24:
        return `${ecName} Overview, Application, Acceptance Rate`
      case len <= 36:
        return `${ecName} Overview, Application Info`
      case len <= 41:
        return `${ecName} Overview, Application`
      case len <= 52:
        return `${ecName} Application`
      default:
        return `${ecName}`
    }
  }

  const returnTitleStringForRoute = (page, titleParam) => {
    switch (page) {
      case pageRoutes.collegeSearch:
        return 'Colleges Explorer With Rankings, Acceptance Rates, Key Stats';
      case pageRoutes.collegeDetailGeneric:
        return collegeDetailTitleHandler(titleParam)
      case pageRoutes.majorSearch:
        return 'College Majors Explorer With Popularity and Earnings Data';
      case pageRoutes.majorDetailGeneric:
        return majorDetailTitleHandler(titleParam)
      case pageRoutes.ecSearch:
        return 'Extracurricular Activities Explorer - Summer Programs, Competitions';
      case pageRoutes.ecDetailGeneric:
        return ecDetailTitleHandler(titleParam)
      case pageRoutes.testScoreStrategy:
        return 'Guidance On Test Scores (SAT & ACT) For College Applications';
      case pageRoutes.collegeDataVisualization:
        return 'College Data Benchmarks for SAT/ACT Scores, GPA, Class Rank';
      case pageRoutes.about:
        return 'About NextFour';
      case pageRoutes.faq:
        return 'Frequently Asked Questions';
      case pageRoutes.contact:
        return 'Contacting NextFour';
      case pageRoutes.privacyPolicy:
        return 'Privacy Policy';
      case pageRoutes.termsOfService:
        return 'Terms and Conditions';
      case pageRoutes.advisorSearch:
        return 'NextFour Advisors Network'
      case pageRoutes.advisorDetailGeneric:
        // Pass an object containing firstName, schoolName, and if available -- majors. majors will be a string, with majors separated by commas if multiple
        return titleParam?.majors ? `Advisor - ${titleParam.firstName ? titleParam.firstName : ''} - ${titleParam.schoolName ? titleParam.schoolName : ''} - ${titleParam.majors}` : `Advisor - ${titleParam.firstName ? titleParam.firstName : ''} - ${titleParam.schoolName ? titleParam.schoolName : ''}`
      case pageRoutes.advisorNetwork:
        return 'Advisors Network Overview'
      case pageRoutes.personalizedExpertHelp:
        return 'Personalized Expert Help For College Admissions Questions'
      case pageRoutes.premiumSpecializedRankings:
        return 'Specialized College Rankings For Earnings, Alumni Success, More'
      case pageRoutes.premiumRDSpend:
        return 'College R&D Spend Report With Rankings By Academic Field'
      case pageRoutes.premiumCrimeSafety:
        return 'College Crime & Safety Report With Rankings For Top Colleges'
      case pageRoutes.overviewIntroduction:
        return `Introduction To The College Admissions Process`
      case pageRoutes.overviewCollegeAppWalkthrough:
        return `Walkthrough Of A Typical College Application`
      case pageRoutes.overviewCollegeAppWalkthroughWithHash(titleParam):
        switch (titleParam) {
          case 'academics':
            return 'College Application Preview - Section on Academics'
          case 'standardized-test-scores':
            return 'College Application Preview - Section on Test Scores'
          case 'extracurricular-activities':
            return 'College Application Preview - Extracurricular Activities'
          case 'honors-and-awards':
            return 'College Application Preview - Section on Honors and Awards'
          case 'letters-of-recommendation':
            return 'College Application Preview - Letters of Recommendation'
          case 'personal-statement-and-supplemental-essays':
            return 'College Application Preview - Personal Statement and Essays'
          case 'intended-field-of-study':
            return 'College Application Preview - Intended Field Of Study'
          default:
            return `Walkthrough Of A Typical College Application`
        }
      case pageRoutes.overviewAdmissionsAdvice:
        return 'Advice For Navigating The College Admissions Process'
      case pageRoutes.overviewAdmissionsAdviceWithHash(titleParam):
        switch (titleParam) {
          case 'identifying-core-application-theme':
            return 'Identifying Core Theme For College Applications'
          case 'selecting-intended-major(s)':
            return 'Advice For Selecting Intended Major(s) For College Applications'
          case 'crafting-an-extracurriculars-profile':
            return 'Crafting an Extracurriculars Profile For College Applications'
          case 'determining-a-standardized-testing-strategy':
            return 'Determining a Strategy for SAT/ACT Standardized Testing'
          case 'maximizing-impact-from-letters-of-recommendation':
            return 'Advice On Letters Of Recommendation For College Applications'
          case 'creating-a-college-interest-list':
            return 'Advice On Creating A Balanced College Interest List'
          case 'applying-early-vs-regular':
            return 'College Admissions Strategy - Applying Early vs Regular'
          case 'overall-reference-timeline':
            return 'Overall Reference Timeline For College Admissions Process'
          default:
            return 'Advice For Navigating The College Admissions Process'
        }
      case pageRoutes.dashboard:
        return `Personalized Dashboard For College Admissions Planning`
      case pageRoutes.ecPremiumInsightsBase:
        return `Data-driven insights about high school extracurriculars`
      case pageRoutes.ecPremiumInsightsWithId(descriptionParam):
        if (titleParam?.length <= 40) {
          return `Exclusive insights for ${titleParam}`
        }
        return `${titleParam}`
      default:
        return 'Get an edge in the college admissions journey with innovative tools and insights';
    }
  };

  const returnDescriptionForRoute: any = (page, descriptionParam) => {

    switch (page) {
      case pageRoutes.collegeSearch:
        return 'Find colleges based on personal preferences and academic profile. Explore admission statistics and benchmarks for admitted students to build a balanced college list.';
      case pageRoutes.collegeDetailGeneric:
        return `Research key facts and figures about ${descriptionParam}, including admission statistics, rankings, student benchmarks, campus safety, and more.`
      case pageRoutes.majorSearch:
        return 'Discover majors that fit your academic and personal interests by exploring this feature which details the actual majors offered at the top-ranked colleges.';
      case pageRoutes.majorDetailGeneric:
        return `Explore the colleges offering a ${descriptionParam} major. Learn about the relative popularity of this major at each college and discover similar majors.`
      case pageRoutes.ecSearch:
        return 'Discover extracurricular activities that fit your profile and strengthen your college applications. Explore activities based on interest areas, impact, and more.';
      case pageRoutes.ecDetailGeneric:
        return `${descriptionParam}`
      case pageRoutes.testScoreStrategy:
        return 'Personalized, data-driven recommendations for submitting your test score(s) to specific colleges and navigate the evolving test-optional college admissions landscape.';
      case pageRoutes.collegeDataVisualization:
        return 'Explore data visualizations for key quantitative admissions considerations (including SAT/ACT test scores, GPA, class rank, etc.) at the top-ranked colleges.'
      case pageRoutes.about:
        return 'NextFour helps families be better informed, and therefore more confident and effective in their decision-making, as they navigate the college admissions process.';
      case pageRoutes.faq:
        return 'Learn more about NextFour and the services we provide.';
      case pageRoutes.contact:
        return 'Learn more about the best points of contact at NextFour.';
      case pageRoutes.privacyPolicy:
        return `Please review NextFour's Privacy Policy.`;
      case pageRoutes.termsOfService:
        return `Please review NextFour's Terms Of Service.`;
      case pageRoutes.advisorSearch:
        return 'Search for advisors that have direct experience with the specific high school extracurricular activities, colleges and majors most relevant for you.'
      case pageRoutes.advisorDetailGeneric:
        // descriptionParam here is the same as titleParam.firstName but we'll pass as the name itself, ensure variable before this is undefined for detailsGroup
        return `Learn about ${descriptionParam}, a NextFour Advisor who is available to help high school students (and families) with the college planning and application process.`
      case pageRoutes.advisorNetwork:
        return 'Connect with recent high school graduates to benefit from their specific expertise to support your college planning and application process.'
      case pageRoutes.personalizedExpertHelp:
        return 'Get personalized expert help from NextFour to support your journey towards college; on-demand answers to all your questions about college admissions'
      case pageRoutes.premiumSpecializedRankings:
        return 'Exclusive college rankings based on tangible success metrics; discover a fresh way to look at colleges based on what matters to you and your aspirations.'
      case pageRoutes.premiumRDSpend:
        return 'Get exclusive access to college research and development (R&D) spend insights and rankings, which indicate the overall strength of research by academic field'
      case pageRoutes.premiumCrimeSafety:
        return 'The best source to easily understand comprehensive college safety data, helping families factor crime statistics into their college evaluation process.'
      case pageRoutes.overviewIntroduction:
        return `Provides a baseline understanding of the holistic college admissions process and the core admissions considerations for applying to U.S. colleges.`
      case pageRoutes.overviewCollegeAppWalkthrough:
        return `Exploration of the core college admissions criteria and illustration of how they surface within the context of an actual college application`
      case pageRoutes.overviewCollegeAppWalkthroughWithHash(titleParam):
        switch (titleParam) {
          case 'academics':
            return `Explanation of how a student's high school academic record is reflected on a typical college application.`
          case 'standardized-test-scores':
            return `Explanation of how a student's standardized test scores (i.e. SAT, ACT, AP Scores, etc.) are reflected on a typical college application.`
          case 'extracurricular-activities':
            return `Explanation of how a student's extracurricular activities and interests are reflected on a typical college application.`
          case 'honors-and-awards':
            return `Explanation of how a student's honors and awards are reflected on a typical college application.`
          case 'letters-of-recommendation':
            return `Explanation of how a typical college application incorporates letter(s) of recommendation.`
          case 'personal-statement-and-supplemental-essays':
            return `Explanation of how a typical college application incorporates essays, such as a personal statement and college-specific supplemental essays.`
          case 'intended-field-of-study':
            return `Explanation of how a student's intended field(s) of study are reflected on a typical college application.`
          default:
            return `Exploration of the core college admissions criteria and illustration of how they surface within the context of an actual college application`
        }
      case pageRoutes.overviewAdmissionsAdvice:
        return `Guidance to help students strategically navigate through high school, prepare for the college application process, and increase chances for gaining admission.`
      case pageRoutes.overviewAdmissionsAdviceWithHash(titleParam):
        switch (titleParam) {
          case 'identifying-core-application-theme':
            return `Advice for developing a core theme (or personal narrative) to help strengthen college applications.`
          case 'selecting-intended-major(s)':
            return `Strategic advice for how to explore and select intended major(s) for college applications and understanding its impact on admissions consideration.`
          case 'crafting-an-extracurriculars-profile':
            return `Strategic advice for developing a strong extracurriculars profile for college applications and a framework to help prioritize which activities to pursue.`
          case 'determining-a-standardized-testing-strategy':
            return `Advice for navigating the evolving test-optional landscape in college admissions and determining an optimal strategy for SAT/ACT testing.`
          case 'maximizing-impact-from-letters-of-recommendation':
            return `Guidance to help students maximize the impact from letters of recommendation included in their college applications.`
          case 'creating-a-college-interest-list':
            return `Guidance for creating a college list including key questions to consider and advice for developing a balanced list including reach, target, and safety schools. `
          case 'applying-early-vs-regular':
            return `Guidance to help high school students with college application strategy including whether to apply Early Action or Early Decision to one or more colleges.`
          case 'overall-reference-timeline':
            return `Multi-year roadmap for the college admissions process to help families be aware and organized across the key dimensions of preparing to apply for college.`
          default:
            return `Guidance to help students strategically navigate through high school, prepare for the college application process, and increase chances for gaining admission.`
        }
      case pageRoutes.dashboard:
        return `AI-powered guidance for navigating the college application journey including identifying intended majors, discovering extracurriculars, and choosing colleges.`
      case pageRoutes.ecPremiumInsightsBase:
        return `Proprietary, data-driven insights on an extracurricular activity's fit and college admissions impact to help build the most impactful extracurriculars profile`
      // descriptionParam is hyphenated from url, and titleParam will be ecObj name
      case pageRoutes.ecPremiumInsightsWithId(descriptionParam):
        return `Proprietary, data-driven insights on fit and college admissions impact for ${titleParam}`
      default:
        return 'Expert, data-driven advice for navigating the admissions process at the most selective colleges, building a college list, researching majors, discovering impactful extracurricular activities, and more.';
    }
  };

  // Set title
  document.title = returnTitleStringForRoute(page, titleParam)


  // Set description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', returnDescriptionForRoute(page, descriptionParam));
  } else {
    const newMetaDescription = document.createElement('meta');
    newMetaDescription.name = 'description';
    newMetaDescription.content = returnDescriptionForRoute(page, descriptionParam);
    document.head.appendChild(newMetaDescription);
  }
}

export const getStripePrice = async (priceID) => {
  let res = await axios.get(`${URL}/get-price/${priceID}`)
  let unitAmount = res.data.unit_amount
  if ((unitAmount / 100) > 0) {
    unitAmount = (unitAmount / 100).toFixed(2)
  }
  return unitAmount
}

// Pass res which is an array of strings separated by '- '
export const returnBulletListFromHyphenSeparatedString = (res) => {
  if (res) {
    let resBullets = res.split('- ').filter((str) => str != '')

    return resBullets.map((res, index) =>
      <ul key={index}>
        <li key={index}>{res}</li>
      </ul>
    )
  }

  else {
    return '-'
  }
}

export const returnParagraphsFromHyphenSeparatedString = (res) => {
  let resParagraphs = res.split('- ').filter((str) => str !== '');

  return resParagraphs ? (
    <div>
      {resParagraphs.map((res, index) => (
        <p key={index}>{res}</p>
      ))}
    </div>
  ) : (<div>-</div>)
};

export const checkAccessToContent = async (token, contentCode) => {
  if (!token) {
    return false
  }

  let user = await getUserByToken(token)

  if (user) {
    let groups = user.data.groups.map(res => res.name)

    return groups.includes(`${contentCode}`) ? true : false
  }

  else {
    return false
  }
}

// Store non null or undefined data, either array of length > 0 or string that is not empty. If localStorage is full, store in session without a timestamp
export const localStorageStore = (key, data) => {
  if (
    (Array.isArray(data) && data.length === 0) ||
    (typeof data === 'string' && data.trim() === '') ||
    data === null ||
    data === undefined
  ) {
    console.warn('Provided data is empty, null, or undefined, skipping store.');
    return;
  }

  const value = {
    timestamp: new Date().toISOString(),
    data: data
  };

  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error: any) {
    if (error.name === 'QuotaExceededError') {
      // Handle when localStorage is full, fallback to sessionStorage
      sessionStorageStore(key, data);
    } else {
      console.error('Error storing in localStorage:', error);
    }
  }
};

// Grab data from localStorage, check timestamp. If no data is in localStorage, check sessionStorage. Data is checked again to make sure it is not empty, undefined, etc
export const localStorageGet = (key) => {
  let storedData: any = localStorage.getItem(key);

  if (storedData) {
    storedData = JSON.parse(storedData);
    // console.log('Local storage present, parsed data for', key, 'is:', storedData)

    if (checkLocalStorageTimestamp(storedData) && storedData.data &&
      (Array.isArray(storedData.data) ? storedData.data.length > 0 : typeof storedData.data === 'string' && storedData.data.trim() !== '')) {
      // console.log('Attempt to return local storage data for', key, 'as:', storedData.data)
      return storedData.data;
    }
  } else {
    storedData = sessionStorage.getItem(key);
    // console.log('Session storage data for', key, 'is:', storedData)

    if (storedData) {
      storedData = JSON.parse(storedData);

      if (storedData &&
        (Array.isArray(storedData) ? storedData.length > 0 : typeof storedData.data === 'string' && storedData.trim() !== '')) {
        // console.log('Attempt to return session storage data for', key, 'as:', storedData)
        return storedData;
      }
    }
  }

  return null;
};

// Returns true if timestampDate is within the last four weeks, false if it is older than 4 weeks
export const checkLocalStorageTimestamp = (localStorageData) => {
  if (!localStorageData || !localStorageData.timestamp) return false;

  const timestampDate = new Date(localStorageData.timestamp);
  const currentDate = new Date();

  const fourWeeksAgo = new Date();
  // 28 days == 4 weeks ago
  fourWeeksAgo.setDate(currentDate.getDate() - 28);

  return timestampDate >= fourWeeksAgo;
};

// Local / sessionStorage handler
export const handleLocalStorageData = async (key, getData) => {
  const storedData = localStorageGet(key);
  // console.log('handleLocalStorageData get return for key,', key, 'is:', storedData)

  if (storedData) {
    return storedData
  }

  // console.log('No valid data found, fetching new data...')
  const data = await getData();
  localStorageStore(key, data);
  return data;
};

// Stores in sessionStorage (no timestamp needed)
export const sessionStorageStore = (key, data) => {

  if (Array.isArray(data) && data.length === 0) {
    console.warn('Provided data is an empty array, skipping store.');
    return;
  }

  else if (typeof data === 'string' && data.trim() === '') {
    console.warn('Provided data is an empty string, skipping store.');
    return;
  }

  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Error storing in sessionStorage:', error);
  }
};

// Retrieves from sessionStorage
export const sessionStorageGet = (key) => {
  const storedData = sessionStorage.getItem(key);
  // console.log('get session storage:', storedData)
  return storedData ? JSON.parse(storedData) : null;
};

// In line CSS variables
export const gray = "rgba(250, 250, 250, 1)"
export const bttnGray = "#FAFAFA"
export const freshGreen = "rgba(218, 248, 185, 1)"
export const selectedTabGreen = '#DAF8B9'
export const unselectedTabGray = '#FFFFFF'
export const titleSpace = '1.75px'